export default __webpack_public_path__ + "static/hero_business_mob_img_10-76c8ef0b1a5a3e704c6f9ae389625a4e.png";